export default __webpack_public_path__ + "static/media/school-icon.b5e9012d.svg";